import { useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import DndList from '../DndList';
import EditionSectionTitle from '../EditionSectionTitle';
import useEditionButtonActions from '../customHooks/useEditionButtonActions';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import styles from './sectionBlock.module.scss';

function ListWrapper({ children, listClassName }) {
  if (listClassName) return <Box className={listClassName}>{children}</Box>;
  return children;
}

export default function SectionBlock({
  tabId,
  sectionId,
  title,
  order,
  visible,
  cards = [],
  type = 'card',
  titleProps = {},
  listClassName = '',
}) {
  const { edition } = useSelector((state) => state.DashboardSlice);
  const { isPrevDisabled, isNextDisabled, moveSection, toggleHideTitle } =
    useEditionButtonActions(tabId);
  const visibleCards = cards.filter((el) => el.visible);
  const hiddenCards = cards.filter((el) => !el.visible);
  const hasHidden = hiddenCards.length > 0;
  const someVisible = visibleCards.length > 0;
  const allHidden = visibleCards.length === 0;

  const movePrev = () => {
    moveSection(sectionId, 'prev');
  };

  const moveNext = () => {
    moveSection(sectionId, 'next');
  };

  const toggleHide = () => {
    toggleHideTitle(sectionId);
  };

  const prevDisabled = isPrevDisabled(sectionId);
  const nextDisabled = isNextDisabled(sectionId);

  return (
    <Box key={sectionId} className={styles.sectionBlock} style={{ order }}>
      {/* ########### VISIBLE CARDS ########### */}
      {someVisible && (
        <EditionSectionTitle
          tabId={tabId}
          sectionId={sectionId}
          movePrev={movePrev}
          moveNext={moveNext}
          toggleHide={toggleHide}
          prevDisabled={prevDisabled}
          nextDisabled={nextDisabled}
          visible={visible}
          {...titleProps}
        >
          {title}
        </EditionSectionTitle>
      )}

      <ListWrapper listClassName={listClassName}>
        <DndList
          tabId={tabId}
          sectionId={sectionId}
          cards={visibleCards}
          type={type}
        />
      </ListWrapper>

      {/* ########### HIDDEN CARDS ########### */}
      {edition.active && hasHidden && (
        <>
          <Box className={styles.hiddenHeader}>
            <Box className={styles.hiddenDivider} />
            <Box className={styles.hiddenLabel}>
              {Trans(translations, 'Hidden')}
            </Box>
            <Box className={styles.hiddenDivider} />
          </Box>

          {allHidden && (
            <EditionSectionTitle
              tabId={tabId}
              sectionId={sectionId}
              movePrev={movePrev}
              moveNext={moveNext}
              toggleHide={toggleHide}
              prevDisabled={prevDisabled}
              nextDisabled={nextDisabled}
              visible={visible}
              {...titleProps}
            >
              {title}
            </EditionSectionTitle>
          )}

          <ListWrapper listClassName={listClassName}>
            <DndList
              tabId={tabId}
              sectionId={sectionId}
              cards={hiddenCards}
              type={type}
            />
          </ListWrapper>
        </>
      )}
    </Box>
  );
}
